import { baseApi } from './apiConfig';

const date = new Date();

export const getAdditionalInfo = propertyId => {
  return baseApi
    .get(`/portal/property/additionalInfo/${propertyId}?_=${date.getTime()}`)
    .then(response => {
      return response.data;
    });
};


export const verifyLicenseDetails = async (licenseNumber, stateId) => {
  try {
      const timestamp = new Date().getTime();
      const response = await baseApi.get(`/portal/verifyLicenseDetails?licenseNumber=${licenseNumber}&stateId=${stateId}&_=${timestamp}`);
      return response.data;
  } catch (error) {
      console.error('Error verifying license details:', error);
      throw error;
  }
};
export const fetchAccessCode = body => {
  return baseApi.post('/portal/accessCode', body).then(response => {
    return response.data;
  });
};

export const isGetCodeAllowed = listingId => {
  return baseApi
    .post(`/portal/v2.0/is-getcode-allowed/${listingId}`)
    .then(response => {
      return response.data;
    });
};
